import { Component, inject } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReferComponent } from '../../modals/refer/refer.component';
import { PresaleDataService } from '../../services/connection-services/data.service';

@Component({
  selector: 'app-refer-and-earn',
  standalone: false,
  templateUrl: './refer-and-earn.component.html',
  styleUrl: './refer-and-earn.component.scss',
})
export class ReferAndEarnComponent {
  modalRef!: BsModalRef<ReferComponent>;
    private readonly modalService = inject(BsModalService);
    private readonly dataService = inject(PresaleDataService);

  referAndEarn(): void {
    if(this.dataService.walletAddress || this.dataService.walletAddressSOL) {
      this.modalRef = this.modalService.show(ReferComponent, {
        class: 'modal-min modal-dialog-centered',
        backdrop: 'static',
        // initialState: { url: this.referUrl },
      });
    } else {
      this.dataService.connectWallet();
    }
    }

}
